import { Row, Flex } from "antd";
import styled from "styled-components";
import { CONSTANT } from "@/util/ant_var";

export const SearchFormRow = styled(Row)`
  margin-bottom: 1rem;
`;

export const ResultsHint = styled.div`
  margin-bottom: 0.5rem;
  font-size: 12px;
  color: ${CONSTANT.SECONDARY};
`;

export const SummaryWrapper = styled.div`
  .report-content {
    padding: 4px 0 0 0;
  }
`;

// Key/value info grid for the Booking and Warrant summary panels. Deliberately
// NOT FolderSearch's InformationContainer/StyledInformation — those hardcode
// value text to CONSTANT.WHITE for FolderSearch's dark preview background;
// reusing them on this Modal's white background renders values invisible
// (white-on-white). This one uses the theme's normal text color instead.
export const SummaryInfoGridRow = styled(Row)``;

export const SummaryInfoItem = styled.div`
  margin-bottom: 12px;

  .info-key {
    display: block;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${CONSTANT.SECONDARY};
  }
  .info-value {
    font-size: 14px;
    color: var(--text-color, #1f1f1f);
  }
`;

export const SummaryHeaderBar = styled(Flex)`
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color, #d9d9d9);
`;

export const SummaryPhotoWrapper = styled.div`
  width: 150px;
  min-width: 150px;
  margin-right: 1.5rem;

  img {
    width: 100%;
    max-width: 150px;
    border: 1px solid var(--border-color, #d9d9d9);
  }
`;

export const SummarySectionTitle = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  font-size: 13px;
  margin: 1rem 0 0.5rem 0;
  color: ${CONSTANT.SECONDARY};
`;

export const SummaryCountsRow = styled(Row)`
  margin-top: 0.5rem;
`;

export const SummaryCountTile = styled.div`
  text-align: center;
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color, #d9d9d9);
  border-radius: 4px;
  min-width: 110px;

  .count-value {
    font-size: 20px;
    font-weight: 700;
  }
  .count-label {
    font-size: 11px;
    text-transform: uppercase;
    color: ${CONSTANT.SECONDARY};
  }
`;

// ── Full Jacket Summary Report (matches reports/JacketSummaryNew.asp) ──
// One long scrollable document — same as the ASP popup, which is a single
// HTML table start to finish, not separate pages.

export const ReportSectionsWrapper = styled.div`
  .bio-header-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;

    td {
      vertical-align: top;
      padding: 2px 6px;
      font-size: 12px;
    }
    .label {
      font-weight: 700;
      white-space: nowrap;
    }
    .name-row {
      font-size: 15px;
      font-weight: 700;
      padding-bottom: 4px;
    }
  }
`;

export const ReportSectionBlock = styled.div`
  margin-bottom: 2px;
`;

// Matches ASP's p.HEADING (background:#D9D9D9)
export const ReportSectionHeaderBar = styled.div`
  background: #d9d9d9;
  color: #000;
  font-weight: 700;
  font-size: 12px;
  padding: 3px 6px;
  margin-top: 6px;
`;

export const ReportEmptyMessage = styled.div`
  padding: 4px 6px;
  font-size: 12px;
  color: var(--text-color, #333);
`;

// One booking's block inside the Arrests section — indented and left-bordered
// so its nested Charges/Detentions tables read as "belonging to" the booking
// header row above them, matching ASP's nested-table look without literally
// nesting <table> elements (which mangles column widths in most browsers).
export const ArrestBlock = styled.div`
  margin: 4px 0 10px 0;
  padding-left: 12px;
  border-left: 3px solid var(--border-color, #d9d9d9);

  .section-header {
    background: #eef1f4;
    font-size: 11px;
    text-transform: uppercase;
  }
`;

export const ReportSectionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    border: 1px solid var(--border-color, #d9d9d9);
    padding: 4px 6px;
    text-align: left;
  }
  th {
    background: var(--table-header-bg, #f0f0f0);
    font-weight: 600;
  }
`;
